// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class ForecastPlantAgg {
  readonly plantId: string;
  readonly plantName: string;
  readonly totalProject: string;
  readonly totalProjectUnit: Enums.Unit;

  constructor(data: { [key: string]: any } = {}) {
    this.plantId = data.plantId === undefined ? NIL_UUID : data.plantId;
    this.plantName = data.plantName === undefined ? '' : data.plantName;
    this.totalProject = data.totalProject === undefined ? '0' : data.totalProject;
    this.totalProjectUnit =
      data.totalProjectUnit === undefined ? Enums.Unit.CuYd : data.totalProjectUnit;
  }

  static zero(): ForecastPlantAgg {
    const zeroValues: ExcludeMethodsDeep<ForecastPlantAgg> = {
      plantId: NIL_UUID,
      plantName: '',
      totalProject: '0',
      totalProjectUnit: Enums.Unit.CuYd,
    };
    return new ForecastPlantAgg(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ForecastPlantAggWireFormat = {
  plantId: string;
  plantName: string;
  totalProject: string;
  totalProjectUnit: string;
};

type NewForecastPlantAggProps = PartialDeep<ForecastPlantAgg, { recurseIntoArrays: true }>;
export const NewForecastPlantAgg: (props: NewForecastPlantAggProps) => ForecastPlantAgg = (props) =>
  new ForecastPlantAgg(props);

type NewForecastPlantAggFromWireFormatProps = PartialDeep<
  ForecastPlantAggWireFormat,
  { recurseIntoArrays: true }
>;
export const NewForecastPlantAggFromWireFormat: (
  props: NewForecastPlantAggFromWireFormatProps,
) => ForecastPlantAgg = (props) => new ForecastPlantAgg(props);
